import React, { useState } from 'react';
import { Alert } from '@mui/material';
import { type ArticuloProduccion } from '../types/articulo';
import { ArticuloService } from '../services/articuloService';
import { LookupButton } from '../../../../components/common/LookupButton';
import ArticuloSelectionModal from './ArticuloSelectionModal';

interface ArticuloLookupProps {
  onSelect?: (articulo: ArticuloProduccion | null) => void;
  buttonText?: string;
  modalTitle?: string;
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

const ArticuloLookup: React.FC<ArticuloLookupProps> = ({
  onSelect,
  buttonText = 'Buscar Artículo',
  modalTitle = 'Seleccionar Artículo',
  variant = 'outlined',
  size = 'medium',
  fullWidth = false
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleSelectArticulo = async (idArticulo: number) => {
    setLoading(true);
    setError(null);

    try {
      const articuloProduccion = await ArticuloService.getArticuloProduccion(idArticulo);

      if (articuloProduccion) {
        if (onSelect) {
          onSelect(articuloProduccion);
        }
      } else {
        setError('No se encontró información de producción para este artículo');
        if (onSelect) {
          onSelect(null);
        }
      }
    } catch (error) {
      setError('Error al obtener la información de producción del artículo');
      if (onSelect) {
        onSelect(null);
      }
    } finally {
      setLoading(false);
      setModalOpen(false);
    }
  };

  return (
    <>
      {error && (
        <Alert
          severity="error"
          onClose={() => setError(null)}
          sx={{ mb: 2 }}
        >
          {error}
        </Alert>
      )}

      <LookupButton
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        onClick={handleOpenModal}
        loading={loading}
      >
        {buttonText}
      </LookupButton>

      <ArticuloSelectionModal
        open={modalOpen}
        onClose={handleCloseModal}
        onSelect={handleSelectArticulo}
        title={modalTitle}
      />
    </>
  );
};

export default ArticuloLookup;